// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { theme } from '@tectonics/look-and-feel/uber-v2/theme';
import { getCountry, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { Link } from '../../atoms';

export function Terms(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'br':
      return <BrazilianTerms />;

    default:
      throw new Error(`No message found for Terms accept in country ${country}`);
  }
}

function BrazilianTerms(): Node {
  return (
    <Paragraph>
      Ao continuar você aceita os
      {'\u00A0'}
      <Link href="https://www.ebanx.com/br/termos" target="_blank" rel="noopener noreferrer">
        termos de uso
      </Link>
      {'\u00A0'}
      do EBANX.
    </Paragraph>
  );
}

const Paragraph = styled.p`
  font-size: .9em;
  text-align: center;
  color: ${theme.colors.black};
`;
